<template>
    <!--Promotion dialigs-->
    <div class="text-xs-center">

        <v-dialog content v-model="showDialog" scrollable width="500" @input="update">

             <v-card class="semi-transparent-8-bg">

                    <v-card-title style="border-bottom: 5px solid #3944bb">

                        <img src="//assets.office4u.xyz/photos/BO-Demo/info.svg" style="float: left; width: 15%; max-width: 50px; margin-right: 15px;"/>

                        <div class="ios-install-guideline-title">

                            <span>{{ $t( 'reusable.ios_install_app_guide_title').toUpperCase() }}</span>

                        </div>

                    </v-card-title>

                    <v-card-text>
                        {{ $t('reusable.ios_install_app_guide')  }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>

                        <v-spacer style="margin-top: 0px; margin-bottom: 0px;"></v-spacer>

                        <v-btn color="primary" flat @click="update">
                            Dismiss
                        </v-btn>

                    </v-card-actions>

                </v-card>

        </v-dialog>

    </div>

</template>

<script>
export default {
    name: "IOS-PWA-Install-Guideline-Dialog",
    props: ["dialog"],
    data() {
        return {
            display: false
        }
    },
    computed: {
        showDialog: {
            get () {
                return this.dialog;
            },
            set(newValue){
                this.display = newValue;
            }
        }
    },
    methods: {
        update() {

            let display = ! this.showDialog;

            this.$emit("DialogChanged", display);

        }

    }

}
</script>

<style scoped>

    .close-icon {
        position: absolute;
        right: 0px;
        font-size: 25px;
        color: rgb(246 246 246);
        cursor: pointer;
        background-color: #000000;
        border-radius: 12px;
        margin: 10px;
    }

    .close-icon:hover {
        color:#000000;
        background-color:rgb(246 246 246);
    }

    .ios-install-guideline-title{
        font-size: calc(1.0em + 1.5vmin);
        color: #3944bb;
    }

</style>
